import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  items: [],
};

export const saleReturnSlice = createSlice({
  name: "saleReturn",
  initialState,
  reducers: {
    selectForReturn: (state, action) => {
      state.items = action.payload;
    },
    itemSelection: (state, action) => {
      const { index, value, key } = action.payload;
      state.items[index][key] = value;
    },
    toRemoveItems: (state, action) => {
      state.items = [];
    },
    toEditItem: (state, action) => {
      const { index, value, key } = action.payload;
      state.items[index][key] = value;
    },
    toRemoveItem: (state, action) => {
      const i = action.payload;
      state.items.splice(i, 1);
    },
  },
});

export const { selectForReturn, toRemoveItems, toEditItem, toRemoveItem } =
  saleReturnSlice.actions;

export default saleReturnSlice.reducer;
